import { FC, MouseEvent } from 'react';
import useTranslate from 'lib/languages/useTranslate';

interface NewCardProps {
    onAddCardHolderClick: (event: MouseEvent<HTMLDivElement>) => void;
    isDarkText: boolean;
}

const NewCard: FC<NewCardProps> = ({ onAddCardHolderClick, isDarkText }) => {
    const translate = useTranslate('cards.cardSlider');

    return (
        <div
            className={`content new-card ${isDarkText ? 'dark-text' : ''}`}
            onClick={onAddCardHolderClick}
        >
            <i className="icon fa fa-plus"></i>
            <p className="title">{translate('issueCard')}</p>
        </div>
    );
};

export default NewCard;
